<app-observation-nav
    [observationSummary]="observationSummary"
    [observationType]="navigationObservationInfo.navigationObservationType"
    [observationEvaluator]="observationSummary?.evalUser?.displayName" 
    [observationSchoolYear]="observationSummary?.schoolYear"
    [observationId]="navigationObservationInfo.navigationObservationId"
    [createdDate]="observationSummary?.dateCreated" 
    [observationFiles]="observationFiles"
    [resourceFile]="resourceFile"
    [isDashboard]="navigationObservationInfo.isDashboard"
    [userRole]="observationDetails?.targetUserRole">
</app-observation-nav>
<hr />

<ntpe-navigation (navigate)="navigateTab($event)" [tabIndex]="tabIndex" [rubricNavigationEnabled]="observationDetails?.permissions?.rubric?.canView"></ntpe-navigation>
<hr />

<form [formGroup]="actionPlanForm" errorTailor>
    <app-ntpe-section-one-goals
        *ngIf="tabIndex==1"
        (save)="onSaveActionPlan(actionPlanForm)"
        (continue)="navigateTab(2)"
        (feedback)="onFeedback()"
        (actionPlanChanged)="onActionPlanChanged()"
        [actionPlanSaved]="actionPlanSaved"
        [formGroup]="actionPlanForm"
        [readOnly]="readOnly"
        [permissions]="observationDetails?.permissions?.goals">
    </app-ntpe-section-one-goals>

    <app-ntpe-section-two-action-plan
        *ngIf="tabIndex==2"
        (navigate)="navigateTab($event)"
        (approve)="onApproveActionPlan()"
        (save)="onSaveActionPlan(actionPlanForm)"
        (submit)="onSubmitActionPlan(actionPlanForm)"
        (onFocusChange)="onFocusChange($event)"
        (onDomainNativation)="onDomainNavigation($event)"
        [form]="actionPlanForm"
        [readOnly]="readOnly"
        [permissions]="observationDetails?.permissions?.actionPlan"
        [resourceFile]="resourceFile"
        [filterType]="filterType" 
        [observationSummary]="observationSummary"
        [observationDetails]="observationDetails"        
        [currentRubricComponent]="currentRubricComponent"
        [filterType]="filterType"
        [domains]="domains"
        [focusAreas]="focusAreas">
    </app-ntpe-section-two-action-plan>

    
    <app-ntp-section-three-midyear-update
        *ngIf="tabIndex==3"
        (navigate)="navigateTab($event)"
        (approve)="onApproveMidYearUpdate()"
        (submit)="onSubmitMidYearUpdate(rubricForm)"
        (onFocusChange)="onFocusChange($event)"
        (onDomainNativation)="onDomainNavigation($event)"
        [form]="rubricForm"
        [readOnly]="readOnly"
        [permissions]="observationDetails?.permissions?.midYearUpdate"
        [resourceFile]="resourceFile"
        [filterType]="filterType" 
        [observationSummary]="observationSummary"
        [observationDetails]="observationDetails"        
        [currentRubricComponent]="currentRubricComponent"
        [filterType]="filterType"
        [domains]="domains"
        [focusAreas]="focusAreas">
    </app-ntp-section-three-midyear-update>

    <app-ntp-section-four-endyear-update
        *ngIf="tabIndex==4"
        (navigate)="navigateTab($event)"
        (approve)="onApproveEndYearUpdate()"
        (submit)="onSubmitEndYearUpdate(rubricForm)"
        (onFocusChange)="onFocusChange($event)"
        (onDomainNativation)="onDomainNavigation($event)"
        [form]="rubricForm"
        [readOnly]="readOnly"
        [permissions]="observationDetails?.permissions?.endYearUpdate"
        [resourceFile]="resourceFile"
        [filterType]="filterType" 
        [observationSummary]="observationSummary"
        [observationDetails]="observationDetails"        
        [currentRubricComponent]="currentRubricComponent"
        [filterType]="filterType"
        [domains]="domains"
        [focusAreas]="focusAreas">
    </app-ntp-section-four-endyear-update>

    <app-ntp-section-five-rubric
        *ngIf="tabIndex==5"
        (navigate)="navigateTab($event)"
        (save)="onSaveRubric(rubricForm)"
        (submit)="onSubmitRubric(rubricForm)"
        (update)="onUpdateRubric(rubricForm)"
        [form]="rubricForm"
        [readOnly]="readOnly || (observationDetails?.completed ?? true)"
        [permissions]="observationDetails?.permissions?.rubric"
        [domainNavigationData]="domainNavigationData"
        [resourceFile]="resourceFile"
        [observationSummary]="observationSummary"
        [observationDetails]="observationDetails"
        [filterType]="filterType"
        [domains]="domains"
        [focusAreas]="focusAreas"
        [currentRubricComponent]="currentRubricComponent"
        [showTargetUser]="showTargetUser">
    </app-ntp-section-five-rubric>
</form>
<hr />

<app-observation-comments
    title="General Comments"
    [observationType]="observationType"
    [observationSummary]="observationSummary"
    [hideFilter]="true"
    [defaultDomainFilterId]="generalCommentsDomainFilterId"
    subtitle="If you have any general (non-component specific) comments, please add them in this section."
    [isCommentCollapsed]="false"
    attachmentLabel="General Comments"
    [isReadOnly]="observationDetails?.completed ?? true"
    >
</app-observation-comments>